<template>
  <Authentication>
    <div class="auth-layout-form">
      <h4 class="auth-layout-title">ورود به پلتفرم ابری تلاش‌نت</h4>

      <b-form @submit.prevent="onSubmit">
        <b-form-group>
          <b-form-input
            v-model="form.emailOrUsername.value"
            :state="this.validEmailOrUsername"
            placeholder="ایمیل، نام کاربری یا تلفن همراه"
            @update="emailOrUsernameChangeHandler"
          />
          <b-form-invalid-feedback
            class="text-right"
            :state="this.validEmailOrUsername"
          >
            {{ form.emailOrUsername.error }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group>
          <b-form-input
            @update="passwordChangeHandler"
            type="password"
            :state="this.validPassword"
            placeholder="رمز عبور"
            v-model="form.password.value"
          ></b-form-input>
          <b-form-invalid-feedback
            class="text-right"
            :state="this.validPassword"
          >
            {{ form.password.error }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group>
          <LoadingBtn
            block
            type="submit"
            variant="primary"
            :disabled="disabled || loader"
            :loading="loader"
          >
            ورود
          </LoadingBtn>
        </b-form-group>
        <error-messages
          :messages="alertMessage"
          :show="showMessage"
          :dismissible="true"
          @dismissed="dismissedError"
        />
      </b-form>
      <div class="auth-layout-footer">
        <router-link to="/forgot-password"
          >رمز عبورم را فراموش کرده‌ام.</router-link
        >
        <router-link to="/register">ثبت نام جدید</router-link>
      </div>
    </div>
  </Authentication>
</template>

<script>
import Authentication from "../Authentication";
import LoadingBtn from "@/components/LoadingBtn/LoadingBtn";
import { login } from "@/services/auth";
import { mapState, mapActions } from "vuex";
import {
  ON_SHOW_LOADER,
  SHOW_MESSAGE,
  HIDE_MESSAGE,
  SIGNIN_USER_SUCCESS
} from "@/store/mutation-types";
import ErrorMessages from "../../../components/ErrorMessages/ErrorMessages.vue";
export default {
  name: "Login",
  components: {
    Authentication,
    LoadingBtn,
    ErrorMessages
  },
  data() {
    return {
      form: {
        emailOrUsername: {
          value: "",
          error: ""
        },
        password: {
          value: "",
          error: ""
        }
      },
      validEmailOrUsername: null,
      validPassword: null,
      disabled: true
    };
  },
  computed: {
    ...mapState("auth", [
      "authToken",
      "loader",
      "alertMessage",
      "showMessage",
      "initURL"
    ])
  },
  methods: {
    ...mapActions("auth", [
      ON_SHOW_LOADER,
      SHOW_MESSAGE,
      HIDE_MESSAGE,
      SIGNIN_USER_SUCCESS
    ]),
    dismissedError: function() {
      this[HIDE_MESSAGE]();
    },
    onSubmit: async function() {
      this[ON_SHOW_LOADER]();
      const [error, data] = await login({
        login: this.form.emailOrUsername.value,
        password: this.form.password.value
      });
      if (error) this[SHOW_MESSAGE](error);
      else {
        if (data.apiStatus === 200) {
          this[SIGNIN_USER_SUCCESS](data.apiData);
          let route = "/";
          if (data.apiData.role === 3) {
            route = this.$route.query.return_to
              ? this.$route.query.return_to
              : "/app/list";
          } else if (data.apiData.role === 2) {
            route = this.$route.query.return_to
              ? this.$route.query.return_to
              : "/admin/dashboard";
          }
          this.$router.push(route);
        } else {
          this[SHOW_MESSAGE](data.apiErrors);
        }
      }
    },
    emailOrUsernameChangeHandler: function(val) {
      if (val === "") {
        this.form.emailOrUsername.error =
          "ایمیل، نام کاربری یا تلفن همراه الزامی است.";
        this.validEmailOrUsername = false;
      } else {
        this.form.emailOrUsername.error = "";
        this.validEmailOrUsername = true;
      }
    },
    passwordChangeHandler: function(val) {
      if (val === "") {
        this.form.password.error = "رمز عبور الزامی است";
        this.validPassword = false;
      } else {
        this.form.password.error = "";
        this.validPassword = true;
      }
    }
  },
  updated() {
    if (this.validEmailOrUsername && this.validPassword) {
      this.disabled = false;
    } else {
      this.disabled = true;
    }
  }
};
</script>
